const root = "_root_19upo_16";
const field = "_field_19upo_26";
const label = "_label_19upo_59";
const message = "_message_19upo_85";
const styles = {
  root,
  field,
  "inline-field": "_inline-field_19upo_32",
  "inline-field-body": "_inline-field-body_19upo_38",
  "inline-field-control": "_inline-field-control_19upo_44",
  label,
  message,
  "help-message": "_help-message_19upo_91",
  "error-message": "_error-message_19upo_95",
  "success-message": "_success-message_19upo_99"
};
export {
  styles as default,
  field,
  label,
  message,
  root
};
//# sourceMappingURL=form.module.css.js.map
